var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g2, _path40, _path41, _g3, _g4, _g5, _g6, _path42, _path43, _g7, _path44, _g8, _path45, _g9, _path46, _path47, _g10, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g11, _g12, _path58, _g13, _path59, _path60, _path61, _path62, _path63, _g14, _path64, _path65, _path66, _g15, _g16, _g17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrafficInsurancePriceIsSetInfographic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218.674,
    height: 214.969,
    viewBox: "0 0 218.674 214.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_11976",
    "data-name": "Group 11976",
    transform: "translate(-527.994 -169.97)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11909",
    "data-name": "Group 11909",
    transform: "translate(533.104 252.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    "data-name": "Path 5342",
    d: "M791.709,1189.978c-7.209-3.981-16.69-1.113-23,6.305s-10.385,30.043-27.817,38.2,4.451,17.8,19.287,9.272S816.559,1203.7,791.709,1189.978Z",
    transform: "translate(-722.882 -1188.181)",
    fill: "#81b830",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5343",
    "data-name": "Path 5343",
    d: "M766.42,1394.7h-162.1s-24.224-25.606-6.792-47.862,35.77-14.119,57.051-39.725,30.926-38.377,63.074-37.42S808.892,1310.452,766.42,1394.7Z",
    transform: "translate(-591.223 -1263.063)",
    fill: "#81b830",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M2458.467,1335.855a56.609,56.609,0,0,1,13.56,4.872,55.619,55.619,0,0,1,11.824,8.122,54.246,54.246,0,0,1,9.194,10.784,54.92,54.92,0,0,1,3.45,6.111,58.527,58.527,0,0,1,2.69,6.424,65.688,65.688,0,0,1,3.2,13.414,82.659,82.659,0,0,1,.665,13.65,83.721,83.721,0,0,1-1.532,13.536,65.055,65.055,0,0,1-3.957,13.032,94.127,94.127,0,0,0,2.214-13.257,109.893,109.893,0,0,0,.481-13.322,99.629,99.629,0,0,0-1.188-13.216,72.053,72.053,0,0,0-3.186-12.823,62.8,62.8,0,0,0-5.648-12,57.126,57.126,0,0,0-8.3-10.571,60.437,60.437,0,0,0-10.767-8.556A70.077,70.077,0,0,0,2458.467,1335.855Z",
    transform: "translate(-2307.569 -1323.921)",
    fill: "#d7e3f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11914",
    "data-name": "Group 11914",
    transform: "translate(527.994 343.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11910",
    "data-name": "Group 11910",
    transform: "translate(1.265 8.876)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M738.862,2445.049s2.959-21.483-2.933-19.363S732.741,2436.416,738.862,2445.049Z",
    transform: "translate(-717.376 -2425.539)",
    fill: "#81b830"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M761.927,2429.267a2.252,2.252,0,0,1-.548-1,3.045,3.045,0,0,0-.645-1.086,2.4,2.4,0,0,0-1.388-.648,8.757,8.757,0,0,1-1.528-.164c-.02-.006-.033-.02-.052-.027a5.331,5.331,0,0,1,1.249-.657c1.9-.683,2.876,1.091,3.331,3.8A1.691,1.691,0,0,1,761.927,2429.267Z",
    transform: "translate(-740.462 -2425.542)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M733.5,2460.411a16.336,16.336,0,0,0,.574,4.723,18.046,18.046,0,0,0,.726,1.918,2.875,2.875,0,0,0,.956,1.283c.983.649,2.14-.015,2.84-.768a13.176,13.176,0,0,1,1.286-1.431,90.7,90.7,0,0,1-.736,9.908c-4.652-6.562-7.306-13.092-5.732-16.785A6.054,6.054,0,0,1,733.5,2460.411Z",
    transform: "translate(-717.661 -2456.534)",
    fill: "#202234",
    opacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M565.523,2488.894s-12.05-21.191-20.363-13.9S565.523,2488.894,565.523,2488.894Z",
    transform: "translate(-543.648 -2469.592)",
    fill: "#81b830"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M596.972,2478.506a6.4,6.4,0,0,1-1.02.066h-.063c.031-.008-.292-.064-.34-.081a2.541,2.541,0,0,1-.875-.555,9.4,9.4,0,0,0-1.535-1.349,14.119,14.119,0,0,0-4.455-1.219c-.658-.131-1.788-.182-2.06-.924a.812.812,0,0,1-.027-.448c3.413-1.244,7.2,1.211,10.454,4.494C597.025,2478.494,597,2478.5,596.972,2478.506Z",
    transform: "translate(-583.109 -2469.777)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5350",
    "data-name": "Path 5350",
    d: "M545.553,2530.2a6.792,6.792,0,0,0,3.7,1.176,10.358,10.358,0,0,1,2.109.107,3.061,3.061,0,0,1,1.654,1.048,8.038,8.038,0,0,0,2.893,2.335,9.708,9.708,0,0,0,4.042.586c.556-.016,1.09-.084,1.641-.143a2.454,2.454,0,0,1,1.367.09c.506.278.5,1.139.415,1.628a2.78,2.78,0,0,1-.381.97c-5.759-1.552-19.006-5.633-19.242-10.385A4.846,4.846,0,0,0,545.553,2530.2Z",
    transform: "translate(-543.743 -2519.362)",
    fill: "#202234",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11913",
    "data-name": "Group 11913",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11911",
    "data-name": "Group 11911"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5351",
    "data-name": "Path 5351",
    d: "M534.178,2355.562H638.207l-1.492-5.2-3.509-12.317a17.753,17.753,0,0,0-20.046-12.616l-4.5.781a5.976,5.976,0,0,1-6-2.6,17.752,17.752,0,0,0-30.943,2.543l-.767,1.7a5.981,5.981,0,0,1-7.9,3l-4.491-2.011a5.991,5.991,0,0,0-7.175,1.776,5.848,5.848,0,0,0-1.193,2.685l-.668,3.893a5.964,5.964,0,0,1-1.066,2.529c-.1.128-.2.256-.3.369a6.019,6.019,0,0,1-3.495,1.99,5.306,5.306,0,0,1-1.065.1,5.9,5.9,0,0,1-3.306-1,5.935,5.935,0,0,0-7.463.816l-3.018,3.018A6.172,6.172,0,0,0,534.178,2355.562Z",
    transform: "translate(-527.994 -2315.71)",
    fill: "#81b830",
    opacity: 0.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5352",
    "data-name": "Path 5352",
    d: "M691.016,2521.388c.643-1.977,3.074-3.85,5.224-3.374a.472.472,0,0,0,.565-.321c.49-1.346-.111-3.5,1.362-4.33a3.8,3.8,0,0,1,3.735.445c2.6,1.806,2.534,5.169,3.017,7.976a.462.462,0,0,0,.767.2,14.541,14.541,0,0,0,1.356-2.207,29.32,29.32,0,0,1,1.924-2.96c.448-.587,1.146-1.581,1.942-1.712,1.027-.169.954,1.669.82,2.281-.33,1.509-1.18,2.832-1.573,4.315a.465.465,0,0,0,.321.565,2.184,2.184,0,0,0,1.737-.465,5.467,5.467,0,0,1,1.962-1.063c1.129-.256,2.96-.252,3.6-1.436a2.8,2.8,0,0,0,.152-1.4c-.02-.893-.109-1.782-.114-2.676a10.145,10.145,0,0,1,1.221-4.959,20.494,20.494,0,0,1,5.736-6.312,21.106,21.106,0,0,1,7.439-3.664c5.141-1.309,11.031-.112,14.3,4.32a14.959,14.959,0,0,1,2.64,6.624,30.944,30.944,0,0,1-.24,8.38c-.208,1.727-.495,3.45-.872,5.151h-56.65A4.043,4.043,0,0,1,691.016,2521.388Z",
    transform: "translate(-677.649 -2484.912)",
    fill: "#202234",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    "data-name": "Path 5353",
    d: "M674.875,2319.605a17.615,17.615,0,0,1-4.728,1.4,9.114,9.114,0,0,0-3.7,1.814c-1.647,1.387-2.6,3.363-3.7,5.167-1.321,2.167-3.136,4.3-5.649,5.063-2.769.843-5.135-1.142-7.794-1.536a9.1,9.1,0,0,0-6.152,1.117,12.357,12.357,0,0,0-4.252,4.856c-.989,1.861-1.979,3.721-3.978,4.651a9.655,9.655,0,0,1-8.014-.235,14.92,14.92,0,0,1-2.439-1.4,5.776,5.776,0,0,1,4.5.8,5.9,5.9,0,0,0,3.306,1,5.305,5.305,0,0,0,1.065-.1,6.019,6.019,0,0,0,3.495-1.99c.1-.113.2-.241.3-.369a5.966,5.966,0,0,0,1.066-2.529l.668-3.893a5.848,5.848,0,0,1,1.193-2.685,5.991,5.991,0,0,1,7.175-1.776l4.491,2.01a5.981,5.981,0,0,0,7.9-3l.767-1.7a17.652,17.652,0,0,1,17.6-10.381A8.8,8.8,0,0,1,674.875,2319.605Z",
    transform: "translate(-616.674 -2315.81)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M718.129,2558.977h94.847l-1.492-5.2a21.179,21.179,0,0,0-17.759-5.129l-3.509.6-1.89.312a7.2,7.2,0,0,1-1.222.1,7.093,7.093,0,0,1-2.557-.469,7.169,7.169,0,0,1-3.409-2.728,20.886,20.886,0,0,0-4.135-4.6,16.862,16.862,0,0,0-1.847-1.378,21.284,21.284,0,0,0-31.071,9.035l-.924,2.018a7.184,7.184,0,0,1-9.49,3.608l-2.728-1.222-2.628-1.179a7.19,7.19,0,0,0-10.03,5.342Z",
    transform: "translate(-702.764 -2519.125)",
    fill: "#d7e3f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    "data-name": "Path 5355",
    d: "M877.282,2550.547a1.849,1.849,0,1,0,1.849-1.849A1.849,1.849,0,0,0,877.282,2550.547Z",
    transform: "translate(-849.055 -2529.869)",
    fill: "#8ca9d3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    "data-name": "Path 5356",
    d: "M1161.064,2627.121a1.849,1.849,0,1,0,1.849-1.849A1.849,1.849,0,0,0,1161.064,2627.121Z",
    transform: "translate(-1109.903 -2600.255)",
    fill: "#c3d1e2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M1204.334,2385.369a3.564,3.564,0,1,0,3.563-3.564A3.564,3.564,0,0,0,1204.334,2385.369Z",
    transform: "translate(-1149.677 -2376.464)",
    fill: "#202234",
    opacity: 0.15
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M1207.371,2374.908a3.564,3.564,0,1,0,3.564-3.564A3.563,3.563,0,0,0,1207.371,2374.908Z",
    transform: "translate(-1152.468 -2366.848)",
    fill: "#c3d1e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11912",
    "data-name": "Group 11912",
    transform: "translate(16.022 27.574)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M876.755,2668.221s8.339-10.515,4.532-11.24S876.211,2661.7,876.755,2668.221Z",
    transform: "translate(-864.482 -2656.917)",
    fill: "#81b830",
    opacity: 0.56
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M892.635,2658.421a4.763,4.763,0,0,0-1.133-.277,3.626,3.626,0,0,0-2.372.566,2.427,2.427,0,0,0-.6.665c.749-1.755,1.953-2.718,3.691-2.387.8.152,1.059.739.977,1.566A1.893,1.893,0,0,1,892.635,2658.421Z",
    transform: "translate(-875.42 -2656.922)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M878.536,2748.744a3.361,3.361,0,0,0,1-.42c-1.381,2.114-2.761,3.854-2.761,3.854a31.326,31.326,0,0,1-.093-3.924A1.837,1.837,0,0,0,878.536,2748.744Z",
    transform: "translate(-864.502 -2740.874)",
    fill: "#202234",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    "data-name": "Path 5362",
    d: "M738.523,2670.445s-5.257-14.141-11.058-10.515S738.523,2670.445,738.523,2670.445Z",
    transform: "translate(-726.25 -2659.14)",
    fill: "#81b830"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M775.435,2664.265c-.435-.386-.7-.916-1.151-1.287a6.222,6.222,0,0,0-1.641-.88,3.055,3.055,0,0,1-1.544-.951,1.349,1.349,0,0,1-.134-1.192c2.039.317,3.911,2.4,5.383,4.684A1.7,1.7,0,0,1,775.435,2664.265Z",
    transform: "translate(-767.273 -2659.709)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    "data-name": "Path 5364",
    d: "M765.131,2735.583a5.666,5.666,0,0,1,2.394.589c.316.231.519.582.844.809a3.041,3.041,0,0,0,1.055.428,4.087,4.087,0,0,0,1.627.081c.728,1.529,1.147,2.652,1.147,2.652a53.191,53.191,0,0,1-9.312-4.982A20.052,20.052,0,0,0,765.131,2735.583Z",
    transform: "translate(-759.925 -2728.837)",
    fill: "#202234",
    opacity: 0.15
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M878.12,2727.3s19.4-2.357,14.5-5.438S878.12,2727.3,878.12,2727.3Z",
    transform: "translate(-865.847 -2715.998)",
    fill: "#81b830"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M952.04,2723.01a15.207,15.207,0,0,1-2.731-.375,8.567,8.567,0,0,0-3.49.6,6.235,6.235,0,0,1-1.476.292c2.977-1.734,6.565-3.1,9.028-1.669C953.392,2722.412,952.685,2722.959,952.04,2723.01Z",
    transform: "translate(-926.717 -2716.055)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M883.7,2774.663a12.952,12.952,0,0,0,1.759-.191c.6-.122,1.19-.313,1.791-.444a5.866,5.866,0,0,1,1.131-.12,96.584,96.584,0,0,1-10.258,1.85s.9-.8,2.282-1.808a1.056,1.056,0,0,0,.192.249,2.353,2.353,0,0,0,1.376.45A9.834,9.834,0,0,0,883.7,2774.663Z",
    transform: "translate(-865.847 -2764.454)",
    fill: "#202234",
    opacity: 0.15
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11919",
    "data-name": "Group 11919",
    transform: "translate(652.652 351.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11915",
    "data-name": "Group 11915",
    transform: "translate(69.068 7.069)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5368",
    "data-name": "Path 5368",
    d: "M2925.784,2519.095s-2.357-17.111,2.336-15.422S2930.659,2512.219,2925.784,2519.095Z",
    transform: "translate(-2925.192 -2503.556)",
    fill: "#81b830",
    opacity: 0.71
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5369",
    "data-name": "Path 5369",
    d: "M2928.926,2506.525a1.791,1.791,0,0,0,.436-.792,2.434,2.434,0,0,1,.514-.865,1.916,1.916,0,0,1,1.105-.516,6.982,6.982,0,0,0,1.217-.131c.015,0,.026-.015.041-.021a4.271,4.271,0,0,0-.995-.523c-1.513-.544-2.291.869-2.653,3.029A1.331,1.331,0,0,0,2928.926,2506.525Z",
    transform: "translate(-2928.317 -2503.558)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5370",
    "data-name": "Path 5370",
    d: "M2930.34,2531.33a13.009,13.009,0,0,1-.457,3.761,14.386,14.386,0,0,1-.578,1.528,2.29,2.29,0,0,1-.761,1.022,1.822,1.822,0,0,1-2.261-.611,10.538,10.538,0,0,0-1.024-1.14,72.2,72.2,0,0,0,.587,7.892c3.706-5.226,5.818-10.427,4.565-13.369A4.821,4.821,0,0,0,2930.34,2531.33Z",
    transform: "translate(-2925.251 -2528.242)",
    fill: "#202234",
    opacity: 0.15
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M2928.679,2554.016s9.6-16.878,16.218-11.074S2928.679,2554.016,2928.679,2554.016Z",
    transform: "translate(-2928.397 -2538.642)",
    fill: "#81b830",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M3006.922,2545.742a5.085,5.085,0,0,0,.813.052h.05c-.024-.006.233-.051.271-.064a2.027,2.027,0,0,0,.7-.442,7.476,7.476,0,0,1,1.223-1.074,11.239,11.239,0,0,1,3.548-.971c.524-.1,1.424-.145,1.641-.735a.655.655,0,0,0,.021-.357c-2.719-.991-5.737.965-8.326,3.579C3006.88,2545.732,3006.9,2545.739,3006.922,2545.742Z",
    transform: "translate(-3000.259 -2538.79)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M2964.586,2586.915a5.408,5.408,0,0,1-2.946.937,8.259,8.259,0,0,0-1.68.085,2.438,2.438,0,0,0-1.317.835,6.4,6.4,0,0,1-2.3,1.86,7.733,7.733,0,0,1-3.219.467c-.443-.013-.869-.067-1.307-.114a1.956,1.956,0,0,0-1.089.072c-.4.221-.4.907-.331,1.3a2.215,2.215,0,0,0,.3.773c4.587-1.236,15.138-4.486,15.325-8.272A3.86,3.86,0,0,1,2964.586,2586.915Z",
    transform: "translate(-2948.324 -2578.283)",
    fill: "#202234",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11918",
    "data-name": "Group 11918",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11916",
    "data-name": "Group 11916"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M2153.385,2447.822H2070.53l1.188-4.142,2.8-9.81a14.139,14.139,0,0,1,15.966-10.048l3.587.622a4.76,4.76,0,0,0,4.776-2.071,14.139,14.139,0,0,1,24.645,2.026l.611,1.358a4.764,4.764,0,0,0,6.29,2.393l3.577-1.6a4.771,4.771,0,0,1,5.714,1.415,4.657,4.657,0,0,1,.95,2.139l.532,3.1a4.745,4.745,0,0,0,.849,2.014c.079.1.158.2.238.294a4.793,4.793,0,0,0,2.784,1.584,4.221,4.221,0,0,0,.849.079,4.7,4.7,0,0,0,2.633-.8,4.728,4.728,0,0,1,5.944.65l2.4,2.4A4.916,4.916,0,0,1,2153.385,2447.822Z",
    transform: "translate(-2070.53 -2416.081)",
    fill: "#81b830",
    opacity: 0.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M2496.5,2579.9c-.512-1.574-2.448-3.067-4.161-2.687a.375.375,0,0,1-.449-.255c-.39-1.072.088-2.79-1.085-3.449a3.027,3.027,0,0,0-2.975.355c-2.067,1.438-2.018,4.117-2.4,6.353a.368.368,0,0,1-.611.161,11.6,11.6,0,0,1-1.08-1.758,23.313,23.313,0,0,0-1.532-2.358c-.357-.468-.912-1.259-1.547-1.363-.818-.135-.76,1.329-.653,1.816.263,1.2.939,2.255,1.253,3.437a.37.37,0,0,1-.255.449,1.739,1.739,0,0,1-1.383-.37,4.36,4.36,0,0,0-1.563-.847c-.9-.2-2.357-.2-2.87-1.144a2.227,2.227,0,0,1-.121-1.118c.016-.711.086-1.42.091-2.131a8.087,8.087,0,0,0-.972-3.95,16.326,16.326,0,0,0-4.568-5.028,16.8,16.8,0,0,0-5.925-2.917c-4.094-1.043-8.785-.09-11.393,3.44a11.918,11.918,0,0,0-2.1,5.276,24.632,24.632,0,0,0,.192,6.674c.166,1.376.394,2.748.694,4.1H2496.2A3.221,3.221,0,0,0,2496.5,2579.9Z",
    transform: "translate(-2419.364 -2550.845)",
    fill: "#202234",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M2554.847,2419.185a14.041,14.041,0,0,0,3.765,1.111,7.255,7.255,0,0,1,2.948,1.445,15.686,15.686,0,0,1,2.945,4.115,8.58,8.58,0,0,0,4.5,4.032c2.206.671,4.09-.91,6.208-1.224a7.247,7.247,0,0,1,4.9.89,9.837,9.837,0,0,1,3.387,3.868c.788,1.482,1.577,2.963,3.168,3.7a7.69,7.69,0,0,0,6.383-.187,11.9,11.9,0,0,0,1.943-1.116,4.6,4.6,0,0,0-3.588.634,4.7,4.7,0,0,1-2.633.8,4.223,4.223,0,0,1-.849-.079,4.794,4.794,0,0,1-2.784-1.584c-.079-.09-.158-.192-.237-.294a4.747,4.747,0,0,1-.849-2.014l-.532-3.1a4.659,4.659,0,0,0-.951-2.139,4.771,4.771,0,0,0-5.714-1.415l-3.577,1.6a4.763,4.763,0,0,1-6.29-2.393l-.611-1.358a14.059,14.059,0,0,0-14.018-8.268A7.015,7.015,0,0,0,2554.847,2419.185Z",
    transform: "translate(-2513.422 -2416.162)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M2146.073,2609.834H2070.53l1.188-4.142a16.869,16.869,0,0,1,14.144-4.084l2.8.475,1.5.249a5.779,5.779,0,0,0,.973.079,5.65,5.65,0,0,0,2.037-.374,5.71,5.71,0,0,0,2.716-2.173,16.639,16.639,0,0,1,3.293-3.666,13.468,13.468,0,0,1,1.471-1.1,16.952,16.952,0,0,1,24.747,7.2l.736,1.607a5.722,5.722,0,0,0,7.559,2.875l2.173-.974,2.093-.939a5.728,5.728,0,0,1,7.989,4.254Z",
    transform: "translate(-2070.53 -2578.094)",
    fill: "#81b830",
    opacity: 0.18
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M2845.042,2603.121a1.473,1.473,0,1,1-1.473-1.473A1.473,1.473,0,0,1,2845.042,2603.121Z",
    transform: "translate(-2779.743 -2586.652)",
    fill: "#81b830",
    opacity: 0.4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M2619.019,2664.109a1.473,1.473,0,1,1-1.472-1.473A1.472,1.472,0,0,1,2619.019,2664.109Z",
    transform: "translate(-2571.987 -2642.711)",
    fill: "#81b830",
    opacity: 0.64
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M2553.491,2471.562a2.839,2.839,0,1,1-2.839-2.839A2.838,2.838,0,0,1,2553.491,2471.562Z",
    transform: "translate(-2509.243 -2464.469)",
    fill: "#202234",
    opacity: 0.15
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M2551.072,2463.232a2.839,2.839,0,1,1-2.839-2.839A2.838,2.838,0,0,1,2551.072,2463.232Z",
    transform: "translate(-2507.02 -2456.812)",
    fill: "#81b830",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11917",
    "data-name": "Group 11917",
    transform: "translate(53.063 21.962)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M2827.8,2696.844s-6.642-8.375-3.61-8.952S2828.233,2691.645,2827.8,2696.844Z",
    transform: "translate(-2815.618 -2687.84)",
    fill: "#c3d1e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M2823.905,2689.037a3.807,3.807,0,0,1,.9-.221,2.887,2.887,0,0,1,1.889.451,1.93,1.93,0,0,1,.474.529c-.6-1.4-1.555-2.165-2.939-1.9-.637.121-.843.589-.778,1.248A1.509,1.509,0,0,0,2823.905,2689.037Z",
    transform: "translate(-2815.659 -2687.843)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M2851.461,2760.977a2.69,2.69,0,0,1-.8-.335c1.1,1.683,2.2,3.07,2.2,3.07a24.908,24.908,0,0,0,.074-3.125A1.464,1.464,0,0,1,2851.461,2760.977Z",
    transform: "translate(-2840.682 -2754.708)",
    fill: "#202234",
    opacity: 0.15
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M2877.875,2698.615s4.188-11.262,8.808-8.375S2877.875,2698.615,2877.875,2698.615Z",
    transform: "translate(-2865.693 -2689.611)",
    fill: "#81b830",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M2910.125,2693.693c.346-.308.554-.729.917-1.025a4.936,4.936,0,0,1,1.308-.7,2.431,2.431,0,0,0,1.23-.758,1.075,1.075,0,0,0,.106-.949c-1.624.252-3.115,1.913-4.288,3.731A1.352,1.352,0,0,0,2910.125,2693.693Z",
    transform: "translate(-2894.669 -2690.064)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M2883.5,2750.494a4.513,4.513,0,0,0-1.907.469c-.251.184-.413.463-.672.645a2.416,2.416,0,0,1-.841.341,3.247,3.247,0,0,1-1.3.064c-.58,1.218-.913,2.112-.913,2.112a42.385,42.385,0,0,0,7.417-3.968A16.033,16.033,0,0,1,2883.5,2750.494Z",
    transform: "translate(-2865.693 -2745.122)",
    fill: "#202234",
    opacity: 0.15
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M2739.321,2743.9s-15.45-1.877-11.551-4.332S2739.321,2743.9,2739.321,2743.9Z",
    transform: "translate(-2727.139 -2734.896)",
    fill: "#81b830",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M2737.215,2740.482a12.065,12.065,0,0,0,2.175-.3,6.826,6.826,0,0,1,2.78.475,4.941,4.941,0,0,0,1.175.233c-2.371-1.381-5.229-2.471-7.19-1.329C2736.137,2740.005,2736.7,2740.441,2737.215,2740.482Z",
    transform: "translate(-2735.426 -2734.943)",
    fill: "#f2faff",
    opacity: 0.2,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M2780.507,2781.62a10.362,10.362,0,0,1-1.4-.152c-.48-.1-.947-.25-1.427-.353a4.669,4.669,0,0,0-.9-.1,76.886,76.886,0,0,0,8.17,1.474s-.719-.634-1.818-1.44a.845.845,0,0,1-.152.2,1.873,1.873,0,0,1-1.1.359A7.843,7.843,0,0,1,2780.507,2781.62Z",
    transform: "translate(-2772.768 -2773.488)",
    fill: "#202234",
    opacity: 0.15
  }))))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M888.512,2108.307s-2.564-4.242-1.392-6.539a7.49,7.49,0,0,0,1.111-3.2s2.652,1.978,2.793,4.548-2.358,5.024-2.358,5.024a8.552,8.552,0,0,0,.514-4.858A38.673,38.673,0,0,0,888.512,2108.307Z",
    transform: "translate(-329.821 -1772.739)",
    fill: "#9ab6e2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M759.035,2260.652s-7.072-2.715-7.811-6.586-1.662-4.907-1.662-4.907,5.056-.1,7.636,2.87,1.865,8.275,1.865,8.275a13.067,13.067,0,0,0-3.935-6.345A59.2,59.2,0,0,0,759.035,2260.652Z",
    transform: "translate(-203.661 -1911.161)",
    fill: "#81b830",
    opacity: 0.59
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M3055.506,2398.314s-2.564-4.242-1.392-6.538a7.488,7.488,0,0,0,1.112-3.2s2.652,1.978,2.793,4.548-2.358,5.024-2.358,5.024a8.552,8.552,0,0,0,.514-4.858A38.626,38.626,0,0,0,3055.506,2398.314Z",
    transform: "translate(-2321.693 -2039.31)",
    fill: "#81b830",
    opacity: 0.44
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M3156.737,2582.591s.765-4.9,3.139-5.9a7.483,7.483,0,0,0,2.911-1.738s.759,3.22-.786,5.279-5.037,2.331-5.037,2.331a8.553,8.553,0,0,0,3.518-3.389A38.693,38.693,0,0,0,3156.737,2582.591Z",
    transform: "translate(-2416.305 -2210.625)",
    fill: "#81b830",
    opacity: 0.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11934",
    "data-name": "Group 11934",
    transform: "translate(565.444 197.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(0 0)"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M1100.828,655.949h-99.949a9.477,9.477,0,0,0-9.477,9.477V821.119a9.477,9.477,0,0,0,9.477,9.477h99.949a9.477,9.477,0,0,0,9.476-9.477V665.426A9.476,9.476,0,0,0,1100.828,655.949Z",
    transform: "translate(-991.402 -644.061)",
    fill: "#199b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M1105,1343.89c-.964,7.613-.975,15.3-1.344,22.959-.333,6.9-.814,14.077-3.295,20.6a22.84,22.84,0,0,1-5.927,9.15,20.287,20.287,0,0,1-8.186,4.2c-6.506,1.787-13.389,1.687-19.77,4.027a38.62,38.62,0,0,0-5.384,2.6c-2.2,1.215-4.4,2.414-6.638,3.551a73.371,73.371,0,0,1-13.79,5.578c-8.881,2.426-18.814,1.95-26.456-3.633-6.347-4.637-10.452-11.583-15.171-17.713a38.915,38.915,0,0,0-7.207-7.673c-.14-.1-.284-.2-.426-.3v19.173a34.183,34.183,0,0,0,5.171,9.994,61.52,61.52,0,0,1,4.843,6.5,12.581,12.581,0,0,1,1.452,3.574c.2.926.345,1.86.508,2.792a5.125,5.125,0,0,0,1.834,3.612c2.155,1.575,5.065,2.192,7.634,2.624a43.793,43.793,0,0,0,10.6.254c3.489-.259,6.984-.439,10.481-.564,7.176-.256,14.357-.273,21.536-.274,7.084,0,14.2-.322,21.267.231,3.414.267,6.787.795,10.192,1.137a30.517,30.517,0,0,0,9.2-.407,22.943,22.943,0,0,0,6.771-2.36,10.137,10.137,0,0,0,2.807-2.239,9.744,9.744,0,0,0,1.668-3.457,77.3,77.3,0,0,0,1.759-8.985,27.546,27.546,0,0,1,1.157-4.376c.005-.015.012-.028.017-.042v-88.079C1107.172,1331.636,1105.765,1337.837,1105,1343.89Z",
    transform: "translate(-991.402 -1260.281)",
    fill: "#202234",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11920",
    "data-name": "Group 11920",
    transform: "translate(2.762 18.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M1132.889,895.187h-98.214s-2.55-7.847-4.95-23.553c-1.108-7.253-2.184-16.182-2.962-26.788q-.447-6.083-.748-12.9c-.351-8.139-.513-17.064-.4-26.776q.072-6.292.3-13.027c.294-8.446.792-17.412,1.54-26.9q.717-9.088,1.753-18.812c.24-2.253,1.474-4.233,3.74-4.233h99.207q.174,0,.333.015c2.2.195,3.1,2.33,3.325,4.644C1143.753,828.093,1132.889,895.187,1132.889,895.187Z",
    transform: "translate(-1025.578 -742.198)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921",
    transform: "translate(27.37 18.859)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M1412.789,895.187h-70.956a33.475,33.475,0,0,1,4.191-8.091c3.575-5.08,8-9.533,9.857-15.621.826-2.709.865-5.581,1.828-8.248a13.507,13.507,0,0,1,2.9-4.748c2.611-2.732,6.214-4.229,9.8-5.21,7.691-2.1,16.079-1.987,23.453-5.209a13.747,13.747,0,0,0,7.322-6.746c2.115-4.677,1.239-10.3-.025-15.069-1.788-6.733-5.272-13.012-6.2-19.97a24.724,24.724,0,0,1,1.053-11.312c1.338-3.842,3.225-7.472,4.473-11.348,1.123-3.483,1.7-7.228.562-10.786a19.486,19.486,0,0,0-5.581-8.16c-4.231-3.79-9.861-5.473-15.364-6.346-6.1-.969-12.3-1.009-18.461-1.283-5.244-.235-10.93-.371-15.822-2.477a40.478,40.478,0,0,1-12.959-9,25.8,25.8,0,0,1-2.766-3.37h81.968q.174,0,.333.015c2.157.2,2.668,2.416,3.325,4.644C1423.653,828.093,1412.789,895.187,1412.789,895.187Z",
    transform: "translate(-1330.087 -742.198)",
    fill: "#202234"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M1490.723,530.143a6.846,6.846,0,0,1-.287,1.982,96.981,96.981,0,0,1-44.747,0,6.837,6.837,0,0,1-.287-1.982,7.172,7.172,0,0,1,7.174-7.174h.129a15.413,15.413,0,0,1,30.716,0h.119A7.18,7.18,0,0,1,1490.723,530.143Z",
    transform: "translate(-1408.712 -508.84)",
    fill: "#199b8b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M1585.385,522.97h-.119a15.415,15.415,0,0,0-28.824-6.223c-.089.159-.158.329-.241.492a10.271,10.271,0,0,0,1.415-.172,25.923,25.923,0,0,0,4.763-1.5c1.417-.565,2.809-1.206,4.257-1.692a17.316,17.316,0,0,1,6.382-.96,9.467,9.467,0,0,1,5.232,1.652,3.509,3.509,0,0,1,1.349,1.821,3.6,3.6,0,0,1-.306,2.292,1.93,1.93,0,0,0,.23,2.343,5.166,5.166,0,0,0,2.137,1.236c1.479.521,3.145.828,4.328,1.934a4.04,4.04,0,0,1,1.36,3.54,4.619,4.619,0,0,1-1.978,2.715,14.809,14.809,0,0,1-7.707,2.509c-4.938.382-9.905-.166-14.834.395-1.431.163-2.832.485-4.238.786a105.044,105.044,0,0,0,11.318.6,86.572,86.572,0,0,0,22.373-2.616,6.85,6.85,0,0,0,.287-1.982A7.18,7.18,0,0,0,1585.385,522.97Z",
    transform: "translate(-1510.558 -508.84)",
    fill: "#202234",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11930",
    "data-name": "Group 11930",
    transform: "translate(18.548 69.157)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11926",
    "data-name": "Group 11926",
    transform: "translate(1.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M1251.474,1366.927h8.385a1.14,1.14,0,0,0,1.032-1.164,1.033,1.033,0,0,0-.936-1.162h-8.36a1.157,1.157,0,0,0-1.047,1.162A1.021,1.021,0,0,0,1251.474,1366.927Z",
    transform: "translate(-1250.239 -1364.601)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M1406.577,1366.927h36.965a1.069,1.069,0,0,0,.971-1.164,1.1,1.1,0,0,0-1-1.162H1406.66a1.134,1.134,0,0,0-1.028,1.162A1.041,1.041,0,0,0,1406.577,1366.927Z",
    transform: "translate(-1392.791 -1364.601)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M1936.621,1364.6h-26.007a1.062,1.062,0,0,0-.964,1.162,1.108,1.108,0,0,0,1,1.164h26.088a1.021,1.021,0,0,0,.926-1.164A1.158,1.158,0,0,0,1936.621,1364.6Z",
    transform: "translate(-1856.078 -1364.601)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M1289.876,1446.438h-42.092a1.15,1.15,0,0,0-1.04,1.174,1.046,1.046,0,0,0,.947,1.176h42.19a1.192,1.192,0,0,0-.005-2.35Z",
    transform: "translate(-1246.743 -1439.825)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M1848.967,1446.438h-34.035a1.088,1.088,0,0,0-.986,1.174,1.1,1.1,0,0,0,1,1.176h34.115a1.045,1.045,0,0,0,.947-1.176A1.15,1.15,0,0,0,1848.967,1446.438Z",
    transform: "translate(-1768.108 -1439.825)",
    fill: "#199b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(0.444 13.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M2144.925,1612.863H2136.4a1.08,1.08,0,0,0-.976,1.192,1.143,1.143,0,0,0,1.031,1.194H2145a1.072,1.072,0,0,0,.968-1.194A1.151,1.151,0,0,0,2144.925,1612.863Z",
    transform: "translate(-2063.151 -1606.131)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M1656.246,1612.863h-37.573a1.121,1.121,0,0,0-1.012,1.192,1.1,1.1,0,0,0,1,1.194h37.638a1.084,1.084,0,0,0,.98-1.194A1.138,1.138,0,0,0,1656.246,1612.863Z",
    transform: "translate(-1587.229 -1606.131)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M1242.062,1615.249h26.562a1.124,1.124,0,0,0,1.016-1.194,1.1,1.1,0,0,0-.991-1.192h-26.516a1.151,1.151,0,0,0-1.039,1.192A1.072,1.072,0,0,0,1242.062,1615.249Z",
    transform: "translate(-1241.093 -1606.131)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M1714.892,1531.925h42.435a1.062,1.062,0,0,0,.96-1.186,1.148,1.148,0,0,0-1.037-1.185H1714.9a1.2,1.2,0,0,0,0,2.371Z",
    transform: "translate(-1675.687 -1529.554)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M1244.672,1531.925h34.312a1.11,1.11,0,0,0,1-1.186,1.1,1.1,0,0,0-.993-1.185h-34.246a1.149,1.149,0,0,0-1.038,1.185A1.062,1.062,0,0,0,1244.672,1531.925Z",
    transform: "translate(-1243.499 -1529.554)",
    fill: "#199b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11925",
    "data-name": "Group 11925",
    transform: "translate(0 27.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M1239.212,1710.244h8.586a1.149,1.149,0,0,0,1.037-1.2,1.086,1.086,0,0,0-.982-1.2h-8.57a1.157,1.157,0,0,0-1.045,1.2A1.077,1.077,0,0,0,1239.212,1710.244Z",
    transform: "translate(-1238.024 -1707.846)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M1398.1,1710.244h37.848a1.107,1.107,0,0,0,1-1.2,1.127,1.127,0,0,0-1.018-1.2h-37.782a1.144,1.144,0,0,0-1.034,1.2A1.089,1.089,0,0,0,1398.1,1710.244Z",
    transform: "translate(-1384.062 -1707.846)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M1941.141,1707.846h-26.663a1.1,1.1,0,0,0-1,1.2,1.13,1.13,0,0,0,1.021,1.2h26.71a1.077,1.077,0,0,0,.973-1.2A1.157,1.157,0,0,0,1941.141,1707.846Z",
    transform: "translate(-1858.698 -1707.846)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M1279.683,1791.988h-43.03a1.164,1.164,0,0,0-1.052,1.2,1.077,1.077,0,0,0,.976,1.2h43.11a1.219,1.219,0,0,0,0-2.4Z",
    transform: "translate(-1235.6 -1785.188)",
    fill: "#199b8b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11929",
    "data-name": "Group 11929",
    transform: "translate(0 47.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(0.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M1230.93,1955.822h8.725a1.161,1.161,0,0,0,1.06-1.2,1.086,1.086,0,0,0-.991-1.2h-8.707a1.174,1.174,0,0,0-1.069,1.2A1.074,1.074,0,0,0,1230.93,1955.822Z",
    transform: "translate(-1229.692 -1953.423)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M1392.377,1955.822h38.464a1.109,1.109,0,0,0,1.015-1.2,1.136,1.136,0,0,0-1.036-1.2h-38.383a1.158,1.158,0,0,0-1.055,1.2A1.089,1.089,0,0,0,1392.377,1955.822Z",
    transform: "translate(-1378.079 -1953.423)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M1944.151,1953.423h-27.087a1.107,1.107,0,0,0-1.011,1.2,1.139,1.139,0,0,0,1.041,1.2h27.145a1.074,1.074,0,0,0,.982-1.2A1.174,1.174,0,0,0,1944.151,1953.423Z",
    transform: "translate(-1860.35 -1953.423)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M1271.612,2037.438h-43.756a1.176,1.176,0,0,0-1.076,1.2,1.072,1.072,0,0,0,.988,1.194h43.849a1.208,1.208,0,0,0,0-2.39Z",
    transform: "translate(-1226.779 -2030.648)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M1852.737,2037.438h-35.381a1.208,1.208,0,0,0,.013,2.39h35.456a1.072,1.072,0,0,0,.988-1.194A1.175,1.175,0,0,0,1852.737,2037.438Z",
    transform: "translate(-1768.687 -2030.648)",
    fill: "#199b8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(0 13.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M1221.934,2206.976h27.605a1.129,1.129,0,0,0,1.055-1.177,1.105,1.105,0,0,0-1.031-1.179H1222a1.159,1.159,0,0,0-1.078,1.179A1.078,1.078,0,0,0,1221.934,2206.976Z",
    transform: "translate(-1220.924 -2197.905)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M1713.375,2123.913h44.105a1.074,1.074,0,0,0,1-1.187,1.171,1.171,0,0,0-1.08-1.189h-44.018a1.2,1.2,0,0,0,0,2.375Z",
    transform: "translate(-1672.626 -2121.537)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M1224.662,2123.913h35.663a1.2,1.2,0,0,0,.012-2.375h-35.592a1.17,1.17,0,0,0-1.08,1.189A1.074,1.074,0,0,0,1224.662,2123.913Z",
    transform: "translate(-1223.443 -2121.537)",
    fill: "#199b8b"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11931",
    "data-name": "Group 11931",
    transform: "translate(24.36 33.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M1292.837,932.586v-6.911h.861v6.911Z",
    transform: "translate(-1292.837 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M1354.468,932.586l-3.255-6.07c.02.811.03,1.8.03,2.614v3.456h-.861v-6.911h1.322l3.255,6.07c-.02-.811-.03-1.8-.03-2.615v-3.455h.841l.02,6.911Z",
    transform: "translate(-1345.731 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M1463.206,925.991h-.922a1.359,1.359,0,0,0-1.462-1.372c-.731,0-1.312.341-1.312,1.062,0,.751.431,1.072,1.482,1.312,1.523.35,2.284.971,2.284,2.143a2.125,2.125,0,0,1-2.374,1.994,2.349,2.349,0,0,1-2.635-2.1h.922a1.673,1.673,0,0,0,1.733,1.422c.791,0,1.432-.431,1.432-1.152,0-.842-.481-1.222-1.693-1.5s-2.073-.771-2.073-1.913a2.07,2.07,0,0,1,2.3-1.943A2.15,2.15,0,0,1,1463.206,925.991Z",
    transform: "translate(-1444.899 -923.938)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M1566.016,930.032c0,.221,0,.421-.02.621a2.635,2.635,0,0,1-5.149,0c-.02-.2-.02-.4-.02-.621v-4.357h.861v4.277a5.862,5.862,0,0,0,.02.611,1.731,1.731,0,0,0,3.426,0,5.827,5.827,0,0,0,.02-.611v-4.277h.861Z",
    transform: "translate(-1539.17 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M1675.958,932.586h-.951a5.6,5.6,0,0,1-.371-1.733c-.08-.711-.35-1.182-1.032-1.232-.16-.01-.33-.01-.491-.01h-1.3v2.975h-.861v-6.911h2.264a6.572,6.572,0,0,1,.9.04,1.747,1.747,0,0,1,1.723,1.843,1.655,1.655,0,0,1-1.232,1.633,1.816,1.816,0,0,1,.892,1.583A3.529,3.529,0,0,0,1675.958,932.586Zm-2.824-3.676a6.188,6.188,0,0,0,.671-.02,1.153,1.153,0,0,0,1.112-1.252,1.081,1.081,0,0,0-1.011-1.222,4.283,4.283,0,0,0-.691-.04h-1.4v2.534Z",
    transform: "translate(-1640.393 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M1765.452,930.142l-.811,2.444h-.921l2.484-6.911h1.162l2.384,6.911h-.932l-.821-2.444Zm2.314-.7-1-3.086-1.071,3.086Z",
    transform: "translate(-1725.665 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M1880.646,932.586l-3.255-6.07c.02.811.03,1.8.03,2.614v3.456h-.861v-6.911h1.322l3.255,6.07c-.02-.811-.03-1.8-.03-2.615v-3.455h.842l.02,6.911Z",
    transform: "translate(-1829.386 -925.535)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M1989.916,926.282l.01.1h-.861l-.02-.1a1.865,1.865,0,0,0-1.963-1.663c-1.412,0-2.284,1.232-2.284,2.9,0,1.7.861,2.925,2.224,2.925a1.865,1.865,0,0,0,1.963-1.663l.02-.1h.861l-.01.1a2.623,2.623,0,0,1-2.885,2.344c-2.013,0-3.135-1.543-3.135-3.566,0-2.1,1.3-3.626,3.265-3.626A2.539,2.539,0,0,1,1989.916,926.282Z",
    transform: "translate(-1927.994 -923.938)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M2106.488,932.586h-4.6v-6.911h4.5v.7h-3.636v2.4h3.335v.7h-3.335v2.4h3.736Z",
    transform: "translate(-2036.507 -925.535)",
    fill: "#199b8b"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11932",
    "data-name": "Group 11932",
    transform: "translate(20.619 44.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M1258.218,1063.482a4.349,4.349,0,0,1-3.99,4.574,18.989,18.989,0,0,1-2.256.1H1250.3v5.055h-3.76V1058.8h5.431a19,19,0,0,1,2.256.1A4.349,4.349,0,0,1,1258.218,1063.482Zm-3.927,0a1.542,1.542,0,0,0-1.525-1.734c-.272-.021-.606-.021-1-.021H1250.3v3.509h1.462c.4,0,.731,0,1-.02A1.543,1.543,0,0,0,1254.291,1063.482Z",
    transform: "translate(-1246.541 -1058.51)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M1421.047,1062.678c0,4.616-2.882,7.5-7.373,7.5s-7.374-2.883-7.374-7.5c0-4.638,2.883-7.5,7.374-7.5S1421.047,1058.041,1421.047,1062.678Zm-3.843,0c0-3.071-1.358-4.742-3.53-4.742s-3.53,1.671-3.53,4.742c0,3.05,1.357,4.742,3.53,4.742S1417.2,1065.728,1417.2,1062.678Z",
    transform: "translate(-1393.388 -1055.179)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M1627.773,1073.216h-11.051V1058.8h3.76v11.239h7.29Z",
    transform: "translate(-1586.807 -1058.51)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M1779.066,1073.216V1058.8h3.76v14.413Z",
    transform: "translate(-1736.031 -1058.51)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M1867.156,1060.214l.021.209h-3.76l-.042-.209a2.559,2.559,0,0,0-2.779-2.277c-1.8,0-3.154,1.5-3.154,4.617,0,3.635,1.5,4.867,3.175,4.867a2.682,2.682,0,0,0,2.715-2.486l.042-.209h3.76l-.021.209c-.355,3.468-3.008,5.243-6.622,5.243-3.864,0-6.977-2.507-6.977-7.4,0-5.013,3.217-7.6,7.123-7.6C1864.754,1055.179,1866.863,1057.372,1867.156,1060.214Z",
    transform: "translate(-1804.464 -1055.179)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M2041.759,1073.216H2038V1067.7l-5.076-8.9h4.219l2.841,5.7,2.736-5.7h4.116l-5.077,8.9Z",
    transform: "translate(-1969.373 -1058.51)",
    fill: "#199b8b"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11933",
    "data-name": "Group 11933",
    transform: "translate(78.346 139.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M1972.14,2237.938a11.275,11.275,0,1,0,11.275,11.275A11.273,11.273,0,0,0,1972.14,2237.938Zm0,21.269a10,10,0,1,1,9.994-9.994A9.993,9.993,0,0,1,1972.14,2259.207Z",
    transform: "translate(-1960.865 -2237.938)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M2001.68,2269.963a8.668,8.668,0,0,0-8.351,6.348h-.005v.02a8.673,8.673,0,1,0,8.356-6.367Zm0,.923a7.752,7.752,0,0,1,7.4,5.425h-14.793A7.752,7.752,0,0,1,2001.68,2270.886Zm0,15.52a7.753,7.753,0,0,1-7.6-6.233h15.208A7.753,7.753,0,0,1,2001.68,2286.406Z",
    transform: "translate(-1990.405 -2267.375)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 5.693,
    height: 0.64,
    transform: "translate(6.651 6.912)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 2.438,
    height: 0.64,
    transform: "translate(13.337 6.912)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 5.693,
    height: 0.64,
    transform: "translate(6.651 13.757)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 2.438,
    height: 0.64,
    transform: "translate(13.337 13.757)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 5.693,
    height: 0.64,
    transform: "translate(10.082 15.228)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 2.437,
    height: 0.64,
    transform: "translate(6.651 15.228)",
    fill: "#199b8b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11965",
    "data-name": "Group 11965",
    transform: "translate(620.493 169.97)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M2514.693,175.254a.967.967,0,0,0,.678,1.188h0a.968.968,0,0,0,1.189-.68l1.242-4.567a.968.968,0,0,0-.681-1.189h0a.967.967,0,0,0-1.186.682Z",
    transform: "translate(-2446.608 -169.97)",
    fill: "#28264a"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M2270.044,1087.881a2.621,2.621,0,0,0,.311-1.845c-.064-.318.023-3.224-.8-1.919-.395,1.406-1.5.4-1.62.558-.217.281-.509.433-.544.818a4.268,4.268,0,0,0,.1,1.007c.059.395.076.791.1,1.188a12.808,12.808,0,0,1,.1,1.794c.048.013.083.02.083.02s2.079,4.579,2.369,5.076c.48.391,2.4-1.211,2.4-1.211C2272.737,1093,2271.006,1090.426,2270.044,1087.881Z",
    transform: "translate(-2219.317 -1009.934)",
    fill: "#d7a28e"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11935",
    "data-name": "Group 11935",
    transform: "translate(47.861 77.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M2292.171,1130.5c-5.584-.492-16.578,14.718-16.578,14.718l-7.011-13.7-3.414,2.2s-2.954,21.023,8.674,24.431c6.523,1.912,17.42-12.653,19.252-19.2C2294.167,1135.117,2295.92,1130.835,2292.171,1130.5Z",
    transform: "translate(-2264.833 -1130.492)",
    fill: "#e5ac61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11936",
    "data-name": "Group 11936",
    transform: "translate(47.861 77.623)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M2292.171,1130.5c-1.726-.152-3.97,1.2-6.246,3.135a16.715,16.715,0,0,1-3.31,3.16c-1.045,1.094-2.042,2.217-2.942,3.275-.06.126-.117.255-.166.387a5.465,5.465,0,0,0-.161,2.59,5.08,5.08,0,0,1-.3,2.579c-.581,1.377-1.776,2.82-3.354,2.98-1.551.157-2.648-.873-3.869-1.641a8.375,8.375,0,0,0-1.78-.78,4.221,4.221,0,0,1-1.428-.682c-1.142-1,.768-2.213,1.552-2.573a7,7,0,0,0,2.356-1.253,3.5,3.5,0,0,0,.674-1.139l-4.617-9.023-3.414,2.2s-2.954,21.023,8.674,24.431c6.523,1.912,17.42-12.653,19.252-19.2C2294.167,1135.117,2295.92,1130.835,2292.171,1130.5Z",
    transform: "translate(-2264.833 -1130.493)",
    fill: "#202234"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11939",
    "data-name": "Group 11939",
    transform: "translate(28.595 105.575)"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11938",
    "data-name": "Group 11938",
    transform: "translate(0 92.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11937",
    "data-name": "Group 11937",
    transform: "translate(9.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M2148.27,2629.1s1.468-4.734,2.219-4.671,2.188.77,2.339,1.235-2.585,4.8-3.458,5.054S2147.924,2630.377,2148.27,2629.1Z",
    transform: "translate(-2148.109 -2624.431)",
    fill: "#f4c095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M2149.994,2633.788c-.035-.8-.024-1.609,0-2.413.011-.389.027-.777.013-1.167-.005-.15-.011-.3-.015-.451a24.319,24.319,0,0,0-1.721,4.241c-.346,1.275.227,1.873,1.1,1.619a1.8,1.8,0,0,0,.628-.493C2150.009,2634.679,2150.013,2634.234,2149.994,2633.788Z",
    transform: "translate(-2148.109 -2629.327)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M2149.313,2644.695c-.222-.2-.422-.423-.639-.629a6.261,6.261,0,0,0-1.125,3.1c-.362,1.333.237,1.959,1.149,1.693.533-.156,1.732-1.768,2.6-3.178A3.474,3.474,0,0,1,2149.313,2644.695Z",
    transform: "translate(-2147.44 -2642.479)",
    fill: "#ced9ef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M2027.333,2657.487l-.469-.189s-.475.431-.432.786,1.468,2.019,4.99,4.038,5.466,2.408,5.767,1.747S2027.942,2659.834,2027.333,2657.487Z",
    transform: "translate(-2026.429 -2654.642)",
    fill: "#17143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M2041.672,2662.752c-5.51-1.284-11.7-6.625-10.113-6.669a5.3,5.3,0,0,1,1.479.307c2.166.677,5.456,2.167,6.115,1.271.846-1.148,1.594-.934,1.714-.8.031.034.108.137.22.271.329.39.959,1.041,1.613,1.006.879-.046,1-.039,1.1.406C2044.1,2659.847,2043.66,2660.523,2041.672,2662.752Z",
    transform: "translate(-2030.912 -2653.524)",
    fill: "#2a2659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M2058.923,2660.625a3.978,3.978,0,0,1-.864.666c-.771.436-.505,1.107-2.323,1.618s-4.16-1.748-4.788-2.487c-.368-.435-.242-.533-.076-.54,2.166.677,5.456,2.167,6.116,1.271.845-1.148,1.594-.934,1.714-.8C2058.734,2660.389,2058.811,2660.492,2058.923,2660.625Z",
    transform: "translate(-2048.748 -2657.018)",
    fill: "#17143a"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M2191.932,1479.948c-8.821,11.531-32.1,90.124-32.1,90.124s1.864,4.152,3.591,1.933c23.568-30.288,50.278-74.158,47.53-86.37S2195.514,1475.266,2191.932,1479.948Z",
    transform: "translate(-2149.049 -1476.372)",
    fill: "#241d51"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M2210.951,1485.635c-2.749-12.212-15.437-10.369-19.018-5.687-2.606,3.407-6.475,12.668-10.632,24.025a7.12,7.12,0,0,0,1.141-.11,1.74,1.74,0,0,1,1.373.263,3.545,3.545,0,0,1,.838,3.886c-.439,1.45-1.328,2.722-1.745,4.177a5,5,0,0,0-.058,2.358,8.317,8.317,0,0,0,.8,2.016,13.539,13.539,0,0,1,.955,2.256,8.613,8.613,0,0,1,.282,2.971c-.126,2-.744,3.929-.962,5.918a12.537,12.537,0,0,1-1.245,4.358,20.752,20.752,0,0,1-2.3,3.443c-.869,1.1-1.776,2.169-2.568,3.325a16.027,16.027,0,0,0-2.043,4.2c-1.183,3.674-2,7.491-3.846,10.913-.914,1.69-2.1,3.23-2.927,4.966-.342.717-.6,1.466-.969,2.171a11.594,11.594,0,0,1-1.116,1.75,7.106,7.106,0,0,1-5.828,3.031c-.8,2.668-1.26,4.2-1.26,4.2s1.864,4.152,3.591,1.933C2186.989,1541.717,2213.7,1497.847,2210.951,1485.635Z",
    transform: "translate(-2149.049 -1476.372)",
    fill: "#202234",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11942",
    "data-name": "Group 11942",
    transform: "translate(68.105 112.101)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11941",
    "data-name": "Group 11941",
    transform: "translate(23.679 87.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M2812.161,2649.411s.1-5.745-.745-5.948-2.688.052-3.023.51,1.1,6.224,1.97,6.821S2812.079,2650.939,2812.161,2649.411Z",
    transform: "translate(-2808.343 -2643.392)",
    fill: "#f4c095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M2827.475,2656.8c.331-.873.612-1.762.878-2.656.129-.433.253-.865.409-1.288.061-.164.121-.328.18-.492a28.184,28.184,0,0,1,.353,5.294c-.082,1.529-.931,1.98-1.8,1.383a2.08,2.08,0,0,1-.513-.771C2827.135,2657.773,2827.291,2657.281,2827.475,2656.8Z",
    transform: "translate(-2825.478 -2651.635)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M2814.333,2671.492c.317-.14.619-.312.932-.46a7.267,7.267,0,0,1,.111,3.826c-.086,1.6-.973,2.07-1.881,1.446-.531-.365-1.264-2.575-1.712-4.446A4.028,4.028,0,0,0,2814.333,2671.492Z",
    transform: "translate(-2811.506 -2668.798)",
    fill: "#ced9ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M2829.291,2778.654a1.306,1.306,0,0,1-.471,1.281c-1.624,1.2-7.676,1.223-8.056.729a2.3,2.3,0,0,1-.395-1.2Z",
    transform: "translate(-2819.397 -2767.723)",
    fill: "#17143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M2817.763,2698s-1.838-.028-2.086-.73-.254-.789-.365-1.065c-.353.227.166,2.366.123,3.433s-.189,4.086.448,4.667,4.29-.59,4.29-.59a20.652,20.652,0,0,1-1.263-2.764C2818.359,2699.438,2819.223,2698.048,2817.763,2698Z",
    transform: "translate(-2814.635 -2691.932)",
    fill: "#2a2659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M2842.825,2699.758s.717-3.486-.387-3.524-1.29.068-1.826.53.483,3.1.64,3.37S2842.825,2699.758,2842.825,2699.758Z",
    transform: "translate(-2837.862 -2691.957)",
    fill: "#17143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M2848.223,2737.3s-1.571.394-2.025,1.344-2.544-1.526-2.234-2.563,2.411-.7,2.411-.7A1.8,1.8,0,0,0,2848.223,2737.3Z",
    transform: "translate(-2841.057 -2727.896)",
    fill: "#17143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M2851.824,2740.3s-1.32.331-1.7,1.13-2.137-1.282-1.877-2.154,2.027-.59,2.027-.59A1.516,1.516,0,0,0,2851.824,2740.3Z",
    transform: "translate(-2844.996 -2730.948)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M2868.842,2754.79c-.841.951-4.16,1.675-4.984.977s-.532-3.813,2.625-3.639C2867.785,2752.2,2869.431,2754.124,2868.842,2754.79Z",
    transform: "translate(-2859.01 -2743.333)",
    fill: "#2a2659"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11940",
    "data-name": "Group 11940",
    transform: "translate(5.306 9.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M2875.634,2755.124a2.347,2.347,0,0,1,1.06.107,5.044,5.044,0,0,1-.244.479,1.936,1.936,0,0,0-1.276-.069,6.438,6.438,0,0,0-1.171.379A2.663,2.663,0,0,1,2875.634,2755.124Z",
    transform: "translate(-2874.003 -2755.107)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M2906.114,2757.887a.245.245,0,0,1-.063.373.241.241,0,0,1-.268-.021,2.419,2.419,0,0,0-.26-.179q.133-.232.244-.475A1.591,1.591,0,0,1,2906.114,2757.887Z",
    transform: "translate(-2902.976 -2757.385)",
    fill: "#fff",
    opacity: 0.2
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M2534.9,1559.19s11.1,44.367,8.275,86.484c-.154,2.286-4.434,1.618-4.434,1.618s-23.3-63.288-23.407-86.787C2515.3,1553.768,2534.9,1559.19,2534.9,1559.19Z",
    transform: "translate(-2515.333 -1557.128)",
    fill: "#2a2659"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M2539.169,1647.342a12.733,12.733,0,0,0-.373-4.739c-.376-1.642-.912-3.242-1.427-4.844-.608-1.886-1.221-3.77-1.793-5.667-.589-1.953-1.137-3.921-1.583-5.912a21.757,21.757,0,0,1-.778-5.653c.089-1.961.612-3.9.46-5.872a25.256,25.256,0,0,0-1.6-5.758c-.647-1.979-1.443-4.616-.193-6.553a4.642,4.642,0,0,1,3.664-1.762,33.576,33.576,0,0,1,5.322.165c.327.023.679.05,1.046.073a338.692,338.692,0,0,0-7.01-41.63s-19.6-5.422-19.567,1.315c.109,23.5,23.407,86.787,23.407,86.787S2538.906,1647.318,2539.169,1647.342Z",
    transform: "translate(-2515.333 -1557.128)",
    fill: "#202234",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11952",
    "data-name": "Group 11952",
    transform: "translate(61.743 58.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11951",
    "data-name": "Group 11951"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M2445.973,1105.639c5.49-6.127,16.179-3.818,21.3,1.863s3.715,41.159-1.621,40.948-25.751,7.54-27.992-3.357S2436.136,1116.618,2445.973,1105.639Z",
    transform: "translate(-2436.606 -1084.88)",
    fill: "#f7c06b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M2561.557,1211.606a13.8,13.8,0,0,0-.511,1.786,15.3,15.3,0,0,0-.225,4.748,17.107,17.107,0,0,0,1.258,4.646c1.118,2.75,2.51,5.81,1.266,8.765-.938,2.23-3.2,3.2-4.81,4.852a3.373,3.373,0,0,0-.836,1.55c-.224.741-.394,1.5-.579,2.251-.2.811-.4,1.623-.663,2.416a5.859,5.859,0,0,1-.855,1.806,1.258,1.258,0,0,1-1.26.557,2.877,2.877,0,0,1-1.552-1.445,7.906,7.906,0,0,1-.745-3.526c-.036-.637-.055-1.275-.118-1.91s-.192-1.26-.283-1.89a35.788,35.788,0,0,1-.448-4.88c-.012-1.76.226-3.51.377-5.261.5-5.814.777-11.643,1.016-17.472-.2.605-.414,1.2-.639,1.8a44.721,44.721,0,0,0-1.8,5.351,66.568,66.568,0,0,0-1.418,10.3,62.737,62.737,0,0,1-1.652,9.551c-1.086,4.517-2.38,9.184-2.453,13.858,5.975,1.879,16.345-3.188,20.315-3.031,3.833.152,5.638-18.11,4.453-30.517A14.745,14.745,0,0,1,2561.557,1211.606Z",
    transform: "translate(-2535.898 -1182.859)",
    fill: "#202234",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11950",
    "data-name": "Group 11950",
    transform: "translate(5.752)"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11943",
    "data-name": "Group 11943",
    transform: "translate(0 19.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M2519.767,1132.895c-.482-.188-.167-1.049-.648-1.239-.251.129-1.552,1.036-1.8,1.166.057.39.979.848,1.036,1.237-5.317,11.588-6.677,21.7-10.575,33.256.669,4.3,1.073,8.593,2.057,12.842a62.512,62.512,0,0,0,5.685-11.725c-.425-11.312,1.6-23.261,4.023-34.26.287-.21.529-.454.816-.664C2520.308,1133.266,2519.823,1133.135,2519.767,1132.895Z",
    transform: "translate(-2507.778 -1131.656)",
    fill: "#f15a29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11949",
    "data-name": "Group 11949",
    transform: "translate(5.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11947",
    "data-name": "Group 11947",
    transform: "translate(2.032 3.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M2616.763,1105.734a9.571,9.571,0,0,1,1.862-.194,5.386,5.386,0,0,1,.944.071.322.322,0,0,0,.266.419c.448.093.908.143,1.347.273a1.176,1.176,0,0,1,.462.223c-.029.073.825,1.365-1.192,3.881-.381.475-1.262-.243-.6-2.754.153-.577-2.8,2.163-3.422,2.308-.922.216-1.983-1.419-1-2.546.321-.367.642-1.584.987-1.888C2616.821,1105.176,2616.242,1105.839,2616.763,1105.734Z",
    transform: "translate(-2613.749 -1091.705)",
    fill: "#202234",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11946",
    "data-name": "Group 11946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    "data-name": "Group 11944",
    transform: "translate(2.698 9.72)"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M2632.963,1056.822l-.544,3.026s.575,4.073,4.632.989l-.974-4.889Z",
    transform: "translate(-2632.418 -1055.948)",
    fill: "#d7a28e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M2639.564,1055.948l-3.113.874-.238,1.877c.074.03.149.058.223.085.356.13.72.239,1.068.391a2.122,2.122,0,0,1,.745.494c.211.235.319-.773.333-.459a3.4,3.4,0,0,1-.436,1.424c-.121.3-.188.693-.456.9a1.1,1.1,0,0,1-.7.2c.687.438,1.79.446,3.548-.891Z",
    transform: "translate(-2635.906 -1055.948)",
    fill: "#33133f",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M2599.5,937.3s-1.9,10.158,1.906,10.408,6.42-3.783,6.42-3.783a2.155,2.155,0,0,0,1.693-2.147c.091-1.533-.857-1.258-.857-1.258s.741-3.908-1.983-4.681S2599.5,937.3,2599.5,937.3Z",
    transform: "translate(-2599.032 -935.671)",
    fill: "#d7a28e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11945",
    "data-name": "Group 11945",
    transform: "translate(0.349 3.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M2658.418,1017.014c.041.247-.229.5-.6.56s-.711-.088-.752-.336.229-.5.6-.56S2658.377,1016.766,2658.418,1017.014Z",
    transform: "translate(-2652.718 -1013.9)",
    fill: "#33133f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M2605.994,1017.147c.041.247-.229.5-.6.56s-.711-.088-.752-.336.229-.5.6-.56S2605.953,1016.9,2605.994,1017.147Z",
    transform: "translate(-2604.531 -1014.023)",
    fill: "#33133f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M2605,984.742a.1.1,0,0,1-.09-.052c-.017-.029-.419-.7-1.413-.262a.1.1,0,0,1-.084-.191,1.241,1.241,0,0,1,1.678.35.1.1,0,0,1-.039.142A.1.1,0,0,1,2605,984.742Z",
    transform: "translate(-2603.346 -983.941)",
    fill: "#241d51"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M2647.667,983.29a.1.1,0,0,1-.038-.008.1.1,0,0,1-.058-.136c0-.01.387-.92,1.76-.622a.1.1,0,0,1-.044.2c-1.2-.262-1.52.488-1.522.5A.105.105,0,0,1,2647.667,983.29Z",
    transform: "translate(-2643.989 -982.464)",
    fill: "#241d51"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M2629.117,1003.258a.384.384,0,0,1-.107-.015.557.557,0,0,1-.318-.326.1.1,0,0,1,.011-.093,2.272,2.272,0,0,0,.279-1.36.1.1,0,0,1,.09-.117.1.1,0,0,1,.117.09,2.487,2.487,0,0,1-.28,1.453.309.309,0,0,0,.161.153.3.3,0,0,0,.256-.083.1.1,0,0,1,.127.166A.561.561,0,0,1,2629.117,1003.258Z",
    transform: "translate(-2626.638 -999.819)",
    fill: "#241d51"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M2610.621,996.071c0,.325-.183.589-.405.589s-.4-.265-.4-.591.183-.589.406-.588S2610.622,995.745,2610.621,996.071Z",
    transform: "translate(-2609.291 -994.428)",
    fill: "#241d51"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M2654.792,996.2c0,.326-.182.589-.405.589s-.4-.266-.4-.591.182-.589.405-.588S2654.793,995.876,2654.792,996.2Z",
    transform: "translate(-2649.893 -994.549)",
    fill: "#241d51"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M2714.577,1002.245s.611-.285.729.146a1.928,1.928,0,0,1-.854,1.767s1.067-1.025.722-1.648S2714.612,1002.544,2714.577,1002.245Z",
    transform: "translate(-2705.125 -996.78)",
    fill: "#33133f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M2616.841,1097.794s.786,2.818,1.981,1.973,4.007-3.412,1.138-5.279a5.39,5.39,0,0,1-.322,2.031c-1,1.2-2.7.177-2.7.177a2.354,2.354,0,0,1-1.4-1.9s-2.453,3.493-.947,4.084S2616.841,1097.794,2616.841,1097.794Z",
    transform: "translate(-2612.886 -1081.654)",
    fill: "#eaad5e"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M2582.581,891.452c-4.018.131-2.136-2.008-3.1-1.2-.762.643.225,1.26.664,1.488-.594-.244-5.343-.484-6.188,3.128-1.018,4.349,8.369.121,8.369.121-.627,1.672,1.181,3.542,1.966,4.259-.053.984-1.405,2.055-1.962,3.161-.8,1.581-.632-.477-2.162-.693s-4.46.092-4.306,1.465,1.416,3.013,3.027,2.754c2.349-.378,5.868-1.5,6.081-6.549C2586.634,897.485,2586.5,891.324,2582.581,891.452Z",
    transform: "translate(-2573.885 -890.07)",
    fill: "#241d51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11948",
    "data-name": "Group 11948",
    transform: "translate(3.46 12.48)"
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M2616.7,1044.571a3.242,3.242,0,0,0,2.528-.073C2619.531,1045.053,2617.944,1046.493,2616.7,1044.571Z",
    transform: "translate(-2616.701 -1044.497)",
    fill: "#fcfaf7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M2633.173,1059.379a.883.883,0,0,1-.19-.019.052.052,0,0,1-.039-.063.053.053,0,0,1,.063-.039,1.066,1.066,0,0,0,.88-.255.053.053,0,0,1,.074.006.053.053,0,0,1-.005.074A1.186,1.186,0,0,1,2633.173,1059.379Z",
    transform: "translate(-2631.63 -1057.82)",
    fill: "#33133f",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11961",
    "data-name": "Group 11961",
    transform: "translate(65.06 80.597)"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11958",
    "data-name": "Group 11958",
    transform: "translate(0 33.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11957",
    "data-name": "Group 11957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M2756.079,1642.04s.036-1.579.384-1.87a2.476,2.476,0,0,1,2.167-.571A18.463,18.463,0,0,0,2756.079,1642.04Z",
    transform: "translate(-2733.579 -1634.464)",
    fill: "#d7a28e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11956",
    "data-name": "Group 11956",
    transform: "translate(0 5.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M2687.974,1659.792l-2.943-1.049a4.209,4.209,0,0,0-5.378,2.553l-1.947,5.466a1.386,1.386,0,0,0,.841,1.771l.07.025,2.59-7.27c.334-.936,1.042-1.542,1.581-1.35l6.169,2.2c.539.192.7,1.109.371,2.045l-2.591,7.27.07.025a1.386,1.386,0,0,0,1.771-.841l1.948-5.465A4.209,4.209,0,0,0,2687.974,1659.792Z",
    transform: "translate(-2661.465 -1657.638)",
    fill: "#383b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M2752.347,1657.583a.442.442,0,0,0-.256-.531c-.95-.4-3.568-1.486-4.82-1.824a.6.6,0,0,0-.718.379,2.708,2.708,0,0,0-.249,1.463.54.54,0,0,0,.363.364,26.344,26.344,0,0,0,4.849,1.728C2751.961,1659.187,2752.2,1658.121,2752.347,1657.583Z",
    transform: "translate(-2724.565 -1654.613)",
    fill: "#202234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M2751.438,1671.367a2.606,2.606,0,0,1-1.668-.591,3.016,3.016,0,0,0-.307-.177,1.71,1.71,0,0,0-.612-.093,4,4,0,0,1-1.364-.483c-.215-.1-.451-.131-.658-.25a1.741,1.741,0,0,1-.493-.424c0-.006-.006-.014-.011-.02a1.676,1.676,0,0,0-.018.721.539.539,0,0,0,.363.363,26.338,26.338,0,0,0,4.849,1.728c.381.022.608-.756.76-1.318A1.239,1.239,0,0,1,2751.438,1671.367Z",
    transform: "translate(-2724.567 -1667.593)",
    fill: "#0f1019",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11955",
    "data-name": "Group 11955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M2516.805,1661.738l-6.129,17.2a3.268,3.268,0,0,1-4,2.248l-27.115-9.661a3.26,3.26,0,0,1-1.676-4.27l6.128-17.2a3.124,3.124,0,0,1,3.923-2.037l27.115,9.661A3.131,3.131,0,0,1,2516.805,1661.738Z",
    transform: "translate(-2477.658 -1647.853)",
    fill: "#202234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M2560.786,1753.988a10.607,10.607,0,0,0,3.63,2.469c1.409.578,3.1,1.073,3.771,2.641.256.6.375,1.259.637,1.858a5.3,5.3,0,0,0,1.33,1.7,3.792,3.792,0,0,0,.907.631,1.625,1.625,0,0,0,.849.194,2.356,2.356,0,0,0,.543-.252,7.629,7.629,0,0,1,1.011-.35,1.614,1.614,0,0,1,.814-.047,1.9,1.9,0,0,1,.818.5c.507.475.738,1.237,1.3,1.644a1.154,1.154,0,0,0,1.544-.328,8.271,8.271,0,0,1,1.206-1.2,3.89,3.89,0,0,1,2.68-.624,6.664,6.664,0,0,1,4.824,3.328,4.637,4.637,0,0,1,.634,2.8c-.141,1.2-1.3,3.877-2.274,4.567a5.561,5.561,0,0,1-3.312.854,15.142,15.142,0,0,0-3.764.042,4.943,4.943,0,0,0-1.612.731,10.174,10.174,0,0,0-.989.821l7.751,2.762a3.261,3.261,0,0,0,4-2.244l4.154-11.657Z",
    transform: "translate(-2554.068 -1745.411)",
    fill: "#0f1019",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M2777.581,1711.373l-14.315-5.1a7.1,7.1,0,0,0,2.721,1.659c1.216.473,2.461.868,3.678,1.339,2.193.85,4.66,1.94,5.735,4.184a4.488,4.488,0,0,1,.412,2.956,2.148,2.148,0,0,1-1.337,1.435,5.342,5.342,0,0,1-2.266.266,12.911,12.911,0,0,1-2.411-.4c-.341-.087-.678-.187-1.012-.3a14.62,14.62,0,0,1-1.917-.892,6.365,6.365,0,0,0-1.8-.589,1.922,1.922,0,0,1-.706-.23,1.2,1.2,0,0,1-.377-.391,7.439,7.439,0,0,0-.4,1.645l13.5,4.808,2.256-6.332A3.133,3.133,0,0,0,2777.581,1711.373Z",
    transform: "translate(-2740.184 -1701.551)",
    fill: "#0f1019",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11953",
    "data-name": "Group 11953",
    transform: "translate(16.437 12.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M2683.447,1804.156l-.678-.242a.719.719,0,0,0-.92.437l-.751,2.109a.719.719,0,0,0,.437.92l.678.242a.719.719,0,0,0,.92-.436l.751-2.109A.719.719,0,0,0,2683.447,1804.156Zm-1.4,2.888a.608.608,0,1,1,.778-.366A.608.608,0,0,1,2682.048,1807.044Z",
    transform: "translate(-2681.055 -1803.872)",
    fill: "#fcc61a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11954",
    "data-name": "Group 11954",
    transform: "translate(21.579 14.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M2747.069,1826.824l-.678-.242a.72.72,0,0,0-.92.436l-.751,2.109a.72.72,0,0,0,.437.92l.678.242a.719.719,0,0,0,.919-.436l.752-2.109A.719.719,0,0,0,2747.069,1826.824Zm-1.4,2.888a.608.608,0,1,1,.778-.366A.608.608,0,0,1,2745.67,1829.711Z",
    transform: "translate(-2744.678 -1826.54)",
    fill: "#fcc61a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M2566.148,1735.659l-.488,1.371a141.5,141.5,0,0,1-16.478-4.825,139.645,139.645,0,0,1-16.289-6.921l.489-1.371a139.594,139.594,0,0,0,16.29,6.921A141.183,141.183,0,0,0,2566.148,1735.659Z",
    transform: "translate(-2528.429 -1717.766)",
    fill: "#fcc61a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M2756.426,1585.133a6.65,6.65,0,0,1-.546.751h0s0,0,0,0-.053.076-.118.167h0c-.052.073-.119.16-.193.251h0s-.768,1.078-1.156.989a.465.465,0,0,1-.406-.388.569.569,0,0,1-.626-.008.5.5,0,0,1-.242-.493.553.553,0,0,1-.639-.047.722.722,0,0,1-.3-.641s-.458.283-.682-.344.478-1.3.5-1.335c.106-.14.217-.27.328-.392a.712.712,0,0,1,.093-.1c2.6-1.883,4.941-6.662,5.512-6.654,0,0,2.452.978,2.33,1.62-.318.519-3.529,4.752-3.529,4.752A2.275,2.275,0,0,1,2756.426,1585.133Z",
    transform: "translate(-2729.345 -1576.897)",
    fill: "#d7a28e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M2755.883,1674.8h0v0l-.118.168h0c-.052.073-.119.16-.193.251h0s-.768,1.078-1.156.99a.465.465,0,0,1-.406-.388.569.569,0,0,1-.627-.008.5.5,0,0,1-.242-.493.553.553,0,0,1-.638-.046.723.723,0,0,1-.3-.641s-.458.283-.682-.344a.917.917,0,0,1,.044-.661,1.134,1.134,0,0,0,.417.623.522.522,0,0,0,.174.078c.071.016.145.013.217.022.156.021.233.16.318.279a.988.988,0,0,0,.41.367,1.871,1.871,0,0,0,.418.093.729.729,0,0,1,.4.178,1.122,1.122,0,0,0,.338.259.738.738,0,0,0,.7-.1,2.623,2.623,0,0,0,.385-.335c.159-.155.315-.313.471-.472a9.317,9.317,0,0,0,.767-.837,2.738,2.738,0,0,1-.147.268A6.666,6.666,0,0,1,2755.883,1674.8Z",
    transform: "translate(-2729.348 -1665.809)",
    fill: "#fff",
    opacity: 0.2
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11959",
    "data-name": "Group 11959",
    transform: "translate(21.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M2745.47,1167.513s10.275,8.118,13.665,18.318-13.284,20.461-13.284,20.461l-2.646-1.531a57.772,57.772,0,0,1,7.311-14.891c-5.862-3.81-12.712-13.707-10.979-20C2740.539,1166.233,2745.47,1167.513,2745.47,1167.513Z",
    transform: "translate(-2739.263 -1167.295)",
    fill: "#f7c06b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11960",
    "data-name": "Group 11960",
    transform: "translate(25.082 15.993)",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M2802.959,1365.2a17.708,17.708,0,0,0-.472,3.676,11.468,11.468,0,0,1-1.082,4.155c-.983,2.04-2.611,3.632-3.868,5.492a45.831,45.831,0,0,1-3.546,5.047c-1.133,1.271-2.636,2.651-4.434,2.74a3.507,3.507,0,0,1-1.343-.2c-.121.361-.183.563-.183.563l2.646,1.531s16.674-10.26,13.284-20.461A26.37,26.37,0,0,0,2802.959,1365.2Z",
    transform: "translate(-2788.031 -1365.199)",
    fill: "#202234"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11964",
    "data-name": "Group 11964",
    transform: "translate(0 1.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11963",
    "data-name": "Group 11963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11962",
    "data-name": "Group 11962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M2255.7,621.61a.79.79,0,0,0,.555.97h0a.791.791,0,0,0,.972-.555l12.88-47.365a.791.791,0,0,0-.557-.971h0a.79.79,0,0,0-.969.555Z",
    transform: "translate(-2208.553 -543.028)",
    fill: "#241d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M1789.822,252.194a65.69,65.69,0,0,0-47.726-55.089.637.637,0,0,1-.064-.021l-.161-.044-.09-.025s-.071-.019-.066-.016q-2.508-.675-5.019-1.145l-.042-.007a65.676,65.676,0,0,0-31.09,1.712l-.114.033a66.248,66.248,0,0,0-32.857,22.724c.26-.117.524-.227.788-.335a25.989,25.989,0,0,1,16.752-1.037c.216.059.428.121.642.185a26.073,26.073,0,0,1,17.47,17.375c.026-.023.051-.047.074-.069a26.109,26.109,0,0,1,42.559,11.663c.039-.039.078-.074.12-.11a26.065,26.065,0,0,1,23.748-6.022c.215.051.431.105.645.163a25.988,25.988,0,0,1,12.026,7.156A26.379,26.379,0,0,1,1789.822,252.194Z",
    transform: "translate(-1672.592 -194.723)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M2114.675,264.526a26.109,26.109,0,0,1,42.559,11.663c.039-.039.078-.075.12-.11a65.47,65.47,0,0,0-9.094-50.782A65.485,65.485,0,0,0,2114.675,264.526Z",
    transform: "translate(-2078.949 -222.814)",
    fill: "#241d51",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M2527.856,222.726a65.623,65.623,0,0,1,33.036,44.968c.215.051.431.105.645.163a26,26,0,0,1,14.432,10.066,65.69,65.69,0,0,0-47.727-55.089c-.076-.024-.146-.043-.223-.064Z",
    transform: "translate(-2458.739 -220.452)",
    fill: "#241d51",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M1742.034,196.947a65.619,65.619,0,0,0-51.259,22.045c-.213-.065-.425-.127-.641-.186a26,26,0,0,0-17.54,1.372,65.688,65.688,0,0,1,69.051-23.333c.078.018.15.037.225.058Z",
    transform: "translate(-1672.595 -194.586)",
    fill: "#241d51",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M2242.948,1150.5l1.436.39a.236.236,0,0,1,.165.288l-1.1,4.053c-.407,1.5-.468,3.394,1.554,3.943,1.507.41,2.652-.53,3.227-2.644l.594-2.187a.234.234,0,0,1,.287-.164l1.435.39a.234.234,0,0,1,.165.287l-.586,2.153c-1.165,4.283-3.951,4.212-5.508,3.789-2.788-.758-3.892-3.01-3.03-6.18l1.075-3.954A.234.234,0,0,1,2242.948,1150.5Z",
    transform: "translate(-2195.339 -1073.241)",
    fill: "#241d51"
  }))))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M2255.617,1088.492c-.239-.785-2.074-.993-2.074-.993-.507.226-.125.769-.494,1.148s-.271,1-.685,1.453.115,1.311.246,1.465,1.583.835,1.721.516c.209-.484-1.163-1.289-1.163-1.289s2.3,1.237,2.138.362c-.085-.458-.921-.982-1.381-1.263.694.252,1.821.477,1.713.095-.116-.409-1.071-1.043-1.58-1.357C2254.732,1088.956,2255.8,1089.1,2255.617,1088.492Z",
    transform: "translate(-2205.367 -1013.35)",
    fill: "#e5b1a1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M2272.578,1138.145l-.141.377a.415.415,0,0,0,.389.062C2273.017,1138.494,2272.578,1138.145,2272.578,1138.145Z",
    transform: "translate(-2223.962 -1059.903)",
    fill: "#fcfaf7",
    opacity: 0.25
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M2283.841,1128.772l-.141.377a.415.415,0,0,0,.39.062C2284.28,1129.121,2283.841,1128.772,2283.841,1128.772Z",
    transform: "translate(-2234.314 -1051.288)",
    fill: "#fcfaf7",
    opacity: 0.25
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M2288.128,1113.524l-.141.377a.414.414,0,0,0,.389.062C2288.567,1113.873,2288.128,1113.524,2288.128,1113.524Z",
    transform: "translate(-2238.255 -1037.272)",
    fill: "#fcfaf7",
    opacity: 0.25
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M2287.877,1096.56l-.141.377a.415.415,0,0,0,.39.062C2288.316,1096.909,2287.877,1096.56,2287.877,1096.56Z",
    transform: "translate(-2238.024 -1021.679)",
    fill: "#fcfaf7",
    opacity: 0.25
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(532.729 382.48)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M2597.75,2802.055h-44.194a1.23,1.23,0,1,1,0-2.459h44.194a1.23,1.23,0,0,1,0,2.459Z",
    transform: "translate(-2393.467 -2799.595)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M741.4,2802.055H587.808a1.23,1.23,0,1,1,0-2.459H741.4a1.23,1.23,0,1,1,0,2.459Z",
    transform: "translate(-586.578 -2799.595)",
    fill: "#81b830"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M1044.824,1040.851a13.5,13.5,0,0,1-13.5,13.5,13.713,13.713,0,0,1-1.594-.093c.294-8.446.792-17.412,1.541-26.9h.053A13.5,13.5,0,0,1,1044.824,1040.851Z",
    transform: "translate(-461.193 -788.097)",
    fill: "#202234",
    opacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M1041,1533.243a13.5,13.5,0,0,1-14.988,13.413c-.351-8.139-.513-17.064-.4-26.776a13.675,13.675,0,0,1,1.9-.131A13.494,13.494,0,0,1,1041,1533.243Z",
    transform: "translate(-457.372 -1240.698)",
    fill: "#202234",
    opacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M1054.482,2025.624a13.5,13.5,0,0,1-11.278,13.313c-1.108-7.253-2.184-16.181-2.962-26.787q.37-.021.745-.021A13.5,13.5,0,0,1,1054.482,2025.624Z",
    transform: "translate(-470.851 -1693.287)",
    fill: "#202234",
    opacity: 0.2
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11968",
    "data-name": "Group 11968",
    transform: "translate(547.462 230.163)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 13.495,
    cy: 13.495,
    r: 13.495,
    transform: "translate(0 19.085) rotate(-45)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11967",
    "data-name": "Group 11967",
    transform: "translate(13.261 11.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M944,1069.138q-.088.252-.184.492a8.119,8.119,0,0,1-1.557,2.526,7.05,7.05,0,0,1-.655.626,6.669,6.669,0,0,1-2.568,1.339.634.634,0,0,1-.133.022h-.05a.633.633,0,0,1-.143-.025,6.653,6.653,0,0,1-2.556-1.336,7.224,7.224,0,0,1-1.293-1.422q-.212-.306-.4-.64h0a9.65,9.65,0,0,1-.7-1.582,15.062,15.062,0,0,1-.747-5.678v-.328a.713.713,0,0,1,.712-.712h.942a5.768,5.768,0,0,0,3.913-2.162l.3-.348.3.348a5.768,5.768,0,0,0,3.923,2.162h.932a.713.713,0,0,1,.712.712v.352A15.016,15.016,0,0,1,944,1069.138Z",
    transform: "translate(-932.988 -1059.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M943.422,1067.457a6.142,6.142,0,0,1-4.215,2.3h-.942a.313.313,0,0,0-.312.312v.346a14.672,14.672,0,0,0,.726,5.53,7.638,7.638,0,0,0,2.276,3.468,6.278,6.278,0,0,0,2.414,1.259.172.172,0,0,0,.106,0,6.283,6.283,0,0,0,2.415-1.26,7.645,7.645,0,0,0,2.275-3.469,14.653,14.653,0,0,0,.726-5.523v-.353a.312.312,0,0,0-.312-.312h-.94A6.141,6.141,0,0,1,943.422,1067.457Z",
    transform: "translate(-937.536 -1066.847)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M969.879,1111.005h-.967a.832.832,0,0,1-.832-.831v-.967a.832.832,0,0,0-.831-.832h0a.832.832,0,0,0-.832.832v.967a.832.832,0,0,1-.831.831h-.967a.831.831,0,0,0,0,1.663h.967a.831.831,0,0,1,.831.831v.967a.831.831,0,0,0,.832.831h0a.831.831,0,0,0,.831-.831v-.967a.832.832,0,0,1,.832-.831h.967a.831.831,0,0,0,0-1.663Z",
    transform: "translate(-961.298 -1104.458)",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11971",
    "data-name": "Group 11971",
    transform: "translate(547.462 269.955)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 13.495,
    cy: 13.495,
    r: 13.495,
    transform: "translate(0 19.085) rotate(-45)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11970",
    "data-name": "Group 11970",
    transform: "translate(13.324 11.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11969",
    "data-name": "Group 11969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M944.783,1564.061q-.088.252-.184.492a8.119,8.119,0,0,1-1.557,2.526,7,7,0,0,1-.655.626,6.67,6.67,0,0,1-2.567,1.339.629.629,0,0,1-.133.022h-.05a.619.619,0,0,1-.143-.025,6.649,6.649,0,0,1-2.556-1.336,7.227,7.227,0,0,1-1.293-1.422q-.212-.306-.4-.64h0a9.634,9.634,0,0,1-.7-1.582,15.062,15.062,0,0,1-.747-5.678v-.328a.713.713,0,0,1,.712-.712h.942a5.769,5.769,0,0,0,3.913-2.162l.3-.348.3.348a5.767,5.767,0,0,0,3.923,2.162h.932a.713.713,0,0,1,.712.712v.352A15.018,15.018,0,0,1,944.783,1564.061Z",
    transform: "translate(-933.775 -1554.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M944.208,1562.381a6.141,6.141,0,0,1-4.215,2.3h-.942a.313.313,0,0,0-.312.312v.346a14.671,14.671,0,0,0,.726,5.53,7.64,7.64,0,0,0,2.276,3.468,6.278,6.278,0,0,0,2.414,1.259.172.172,0,0,0,.106,0,6.283,6.283,0,0,0,2.415-1.26,7.647,7.647,0,0,0,2.275-3.469,14.654,14.654,0,0,0,.726-5.523v-.353a.312.312,0,0,0-.312-.312h-.94A6.14,6.14,0,0,1,944.208,1562.381Z",
    transform: "translate(-938.322 -1561.771)",
    fill: "#81b830"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M965.5,1621.871v-.1c0-.009,0-.017,0-.026h0a1.227,1.227,0,0,0-.919-1.162h0l-.062-.014h0l-.392-.079-.877-.177-.008-.019v-.237h0a.146.146,0,0,0-.146-.145h0a.147.147,0,0,0-.041.007,1.736,1.736,0,0,0-.917-.872,7.251,7.251,0,0,0-2.758-.024h0a1.342,1.342,0,0,0-.423.035c-.065.047.149.1.2.121h0a2.584,2.584,0,0,0-.525.813c-.061.134-.113.265-.157.382a.97.97,0,0,0-.526.582.473.473,0,0,0-.106-.007c-.011,0-.022.01-.031.027h0c-.036,0-.065.083-.065.186s.029.186.065.186h0c.009.016.019.026.03.027s0,.027-.006.041,0,.018,0,.026c0,.024-.006.049-.009.074l0,.027q0,.046-.009.093s0,0,0,.007c0,.034-.005.069-.007.1,0,.009,0,.017,0,.026q0,.039,0,.079c0,.005,0,.011,0,.016a.25.25,0,0,0,.147.453h.782a.668.668,0,0,0,.577.453l.056,0a.668.668,0,0,0,.633-.456h3.565a.668.668,0,0,0,.577.453l.056,0a.669.669,0,0,0,.633-.456h.526a.25.25,0,0,0,.151-.451Z",
    transform: "translate(-955.764 -1613.721)",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11975",
    "data-name": "Group 11975",
    transform: "translate(547.462 309.746)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 13.495,
    cy: 13.495,
    r: 13.495,
    transform: "translate(0 19.085) rotate(-45)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11974",
    "data-name": "Group 11974",
    transform: "translate(13.324 11.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11973",
    "data-name": "Group 11973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11972",
    "data-name": "Group 11972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M944.783,2056.893q-.088.252-.184.491a8.117,8.117,0,0,1-1.557,2.526,7.015,7.015,0,0,1-.655.626,6.667,6.667,0,0,1-2.567,1.339.621.621,0,0,1-.133.022l-.025,0-.025,0a.619.619,0,0,1-.143-.025,6.653,6.653,0,0,1-2.556-1.336,7.211,7.211,0,0,1-1.293-1.422q-.212-.305-.4-.639h0a9.646,9.646,0,0,1-.7-1.582,15.064,15.064,0,0,1-.747-5.678v-.328a.713.713,0,0,1,.712-.712h.942a5.77,5.77,0,0,0,3.913-2.162l.3-.348.3.348a5.769,5.769,0,0,0,3.923,2.162h.932a.713.713,0,0,1,.712.712v.352A15.02,15.02,0,0,1,944.783,2056.893Z",
    transform: "translate(-933.775 -2047.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M944.208,2055.212a6.143,6.143,0,0,1-4.215,2.3h-.942a.313.313,0,0,0-.312.312v.345a14.672,14.672,0,0,0,.726,5.53,7.639,7.639,0,0,0,2.276,3.468,6.275,6.275,0,0,0,2.414,1.259.243.243,0,0,0,.054.009.259.259,0,0,0,.053-.008,6.284,6.284,0,0,0,2.415-1.26,7.646,7.646,0,0,0,2.275-3.469,14.654,14.654,0,0,0,.726-5.522v-.353a.313.313,0,0,0-.312-.312h-.94A6.142,6.142,0,0,1,944.208,2055.212Z",
    transform: "translate(-938.322 -2054.602)",
    fill: "#81b830"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M969.927,2113.992l-1.392-.579a1.76,1.76,0,0,0,.125-.186.439.439,0,0,0,.307.021.546.546,0,0,0,.331-.6.786.786,0,0,0-.033-.161.768.768,0,0,0-.131-.251.515.515,0,0,0-.546-.208.471.471,0,0,0-.3.315.95.95,0,0,0-.551.15l-.585.373-1.407-.6a2.06,2.06,0,0,0-1.594-.008l-.578.24,1.533.645a.512.512,0,0,0-.049.165.345.345,0,1,0,.669.1l.349.147-2.258,1.44c-.062-.333-.245-1.055-.669-.968-.466.1-.267,1.248-.2,1.6a.18.18,0,0,0,.021.1h0a.166.166,0,0,0,.214.077l.069-.027a.225.225,0,0,0,.169.257.229.229,0,0,0,.229-.224.285.285,0,0,0-.034-.177l3.82-1.508.692.282a.5.5,0,0,0-.059.181.347.347,0,1,0,.671.082s0-.009,0-.013l1.052.429.134-.059A.56.56,0,0,0,969.927,2113.992Z",
    transform: "translate(-960.498 -2106.809)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrafficInsurancePriceIsSetInfographic);
export default __webpack_public_path__ + "static/media/traffic-insurance-price-is-set-infographic.e2a7f433f48a066771fb25b2c6131bdc.svg";
export { ForwardRef as ReactComponent };